export const DOMAIN_REGEX =
  /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}|(?:[xnXN]--[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*))$/;
